import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=6628db24&scoped=true"
import script from "./InquiryForm.vue?vue&type=script&lang=js"
export * from "./InquiryForm.vue?vue&type=script&lang=js"
import style0 from "./InquiryForm.vue?vue&type=style&index=0&id=6628db24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628db24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Input.vue').default,InputRequire: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/InputRequire.vue').default,Button: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Button.vue').default,SectionContainer: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/SectionContainer.vue').default})
